import keyManager from 'constant-manager'

const errorPhoneCodes = keyManager(
  {
    phoneIsBlocked: 'account-is-blocked',
    countryIsRestricted: 'country-is-restricted',
  },
  {
    prefix: 'error/phone/',
  },
)

export default errorPhoneCodes
